const isFacetSearchParam = (paramKey: string): boolean => {
    const pattern =
        /^(ge_|le_|gt_|lt_|f\.)[a-zA-Z0-9][a-zA-Z0-9 ]*\|[a-zA-Z0-9][a-zA-Z0-9]*$/;
    return !!paramKey.match(pattern);
};

export default isFacetSearchParam;
